import { transport } from 'config/transport';

export function callApiExportBienLaiThuDauNam(classId, studentIds) {
    return transport.get(`/mamnon/thuhocsinh/thudaunam/exportBienLaiPdf/${classId}`, { responseType: 'blob', params: { studentIds } });
}
